import { ReactNode } from 'react';

import { Select } from '@/ui/Select';
import {
  ActionsListStyled,
  ActionsSelectButton,
} from '@/administration/pages/Journey/common/atoms/LearningCard/variants/DnDLearningCard/ActionsSelect/styles';
import { Position, Value } from '@/ui/Select/types';
import { ButtonVariant } from '@/ui/Button/type/icon';

export const BaseActionsSelect = ({
  onChange,
  children,
  forcedPosition = 'bottom-left',
  buttonVariant,
  dropdownMaxWidth,
}: {
  onChange: (value: Value) => void;
  children: ReactNode | ReactNode[];
  forcedPosition?: Position;
  buttonVariant?: ButtonVariant;
  dropdownMaxWidth?: string;
}): JSX.Element => {
  return (
    <Select
      onChange={onChange}
      value={''}
      /**
       * Reasoning:
       * - Since BaseActionsSelect will consist a popover with trigger, we want it to prevent from closing - to keep the popover open.
       */
      autoclose={false}
    >
      <Select.Header>
        {({ toggleShowOptions }) => <ActionsSelectButton onClick={toggleShowOptions} buttonVariant={buttonVariant} />}
      </Select.Header>
      <ActionsListStyled forcedPosition={forcedPosition} $maxWidth={dropdownMaxWidth}>
        {children}
      </ActionsListStyled>
    </Select>
  );
};
